<template>
  <div :style="{height:'100%'}">
    <van-swipe @change="onChange" :show-indicators="false" :style="{height:'100%'}" :autoplay='3000'>
      <van-swipe-item  :style="{height:'100%' }" v-for='(item,index) in imgList' :key='index'>
        <img :src="formatImgUrl(item.pic,700,466,true)" class='contentImg' @click='imgTap(index)' :class='{"round":source}'>
      </van-swipe-item>
    </van-swipe>
    <div class="custom-indicator" v-if='imgList.length > 1' style='margin-top:10px'>
      <div class="center">
        <div v-for='(item,index) in imgList' :class="{ 'actived': current === index }"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'home-swiper',
    data () {
      return {
        current: 0,
      }
    },
    props: {
      imgList : {
        type : Array,
        default : ()=>{
          return []
        }
      },
      source : {
        type : Number,
        default : 0
      }
    },
    created(){
      console.log(this.source)
    },
    methods: {
      imgTap(index){
        this.$emit('imgTap',index)
      },
      formatImgUrl(url, width, height,m_fill) {
        if(url.length < 40){
          return url;
        }
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      onChange (index) {
        this.current = index
      }
    }
  }
</script>

<style scoped lang="scss">
  .round{
    border-radius:6px; 
  }
  .van-swipe{
    
    // background: $theme-color;
    .van-swipe-item{
  
    }
  }
  .contentImg{
    width: 100%;
  }
  .custom-indicator{
    width: 100%;
    display: flex;
    justify-content: center;
    // margin-top: 26px;
    .center{
      width: 188px;
      height: 6px;
      display: flex;
      justify-content: center;
      
      div{
        width: 20px;
        height: 6px;
        border-radius:3px; 
        background: #ECECEC;
        margin-right: 16px;
        &.actived{
          background: #333333;
        }
      }
    }
  }
</style>
